module.exports = __webpack_public_path__ + "img/2.d514141f.jpg";